import { useEffect } from 'react';

const useClickOutside = (ref, callback) => {
  const handleClick = (event) => {
    // Check if the ref exists and if the clicked target is not within the ref element
    if (ref.current && !ref.current.contains(event.target)) {

      // Also check if the clicked target or its parents do not have the excluded class
      let targetElement = event.target; // clicked element

      while (targetElement != null) {
        if (targetElement.classList.contains('click-outside-exclusion')) {
          // This element or its parent has the exclusion class, so we don't call the callback
          return;
        }
        targetElement = targetElement.parentElement;
      }
      callback();
    }
  };

  useEffect(() => {
    // Attach the listeners to the document
    document.addEventListener('mousedown', handleClick);
    document.addEventListener('touchstart', handleClick);

    // Clean up the listeners when the component unmounts
    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('touchstart', handleClick);
    };
  }, [ref, callback]);  // Re-run the effect when the ref or the callback function changes
};

export default useClickOutside;
